import styled from "@emotion/styled";

export const Container = styled.div`
  min-width: 1060px;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  padding: 0px 0px 80px 0px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

export const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
`;

export const UpperSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

export const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

export const Title = styled.div`
  display: flex;
  padding: 24px 20px;
  justify-content: center;
  align-items: center;
`;

export const FilterContainer = styled.div`
  display: flex;
  padding: 0px 20px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

export const PeriodFilter = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  width: 428px;
  p {
    white-space: nowrap;
  }
`;

export const TagFilterContainer = styled.div`
  display: flex;
  padding: 0px 20px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

export const PeriodChips = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SortFilter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
`;

export const OnlyRepeatCheckbox = styled.div`
  display: flex;
  padding: 0px 4px;
  align-items: center;
  gap: 4px;

  cursor: pointer;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;
  gap: 40px;
`;

export const TableContainer = styled.div`
  display: flex;
  min-width: 832px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  height: 100%;
`;
